__turbopack_context__.v({
  "bold": "Sitemap-module-scss-module__RDGsKa__bold",
  "collapsed": "Sitemap-module-scss-module__RDGsKa__collapsed",
  "container": "Sitemap-module-scss-module__RDGsKa__container",
  "disabled": "Sitemap-module-scss-module__RDGsKa__disabled",
  "expanded": "Sitemap-module-scss-module__RDGsKa__expanded",
  "item": "Sitemap-module-scss-module__RDGsKa__item",
  "link": "Sitemap-module-scss-module__RDGsKa__link",
  "list": "Sitemap-module-scss-module__RDGsKa__list",
  "section": "Sitemap-module-scss-module__RDGsKa__section",
  "sectionTitle": "Sitemap-module-scss-module__RDGsKa__sectionTitle",
  "showMoreButton": "Sitemap-module-scss-module__RDGsKa__showMoreButton",
  "subList": "Sitemap-module-scss-module__RDGsKa__subList",
  "subListLevel3": "Sitemap-module-scss-module__RDGsKa__subListLevel3",
  "subsectionHeader": "Sitemap-module-scss-module__RDGsKa__subsectionHeader",
  "subsectionWrapper": "Sitemap-module-scss-module__RDGsKa__subsectionWrapper",
  "title": "Sitemap-module-scss-module__RDGsKa__title",
});
